import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

// Counts of things waiting for the logged-in person to act on — they drive the red dots on the menus.
// Polled gently, refreshed when the tab regains focus and whenever the user moves to another page
// (so the dot clears right after they act on a request).
function useCounts(queryKey, url, enabled) {
  const location = useLocation();
  const q = useQuery({
    queryKey, enabled,
    queryFn: async () => (await api.get(url)).data,
    refetchInterval: 45000, retry: false,
  });
  const { refetch } = q;
  useEffect(() => { if (enabled) refetch(); }, [location.pathname, enabled, refetch]);
  return q.data || {};
}

// Employee portal: unread notifications, team requests to decide, backup requests to answer.
export const useEmployeeActionCounts = (enabled = true) => useCounts(["myActionCounts"], "/my/action-counts", enabled);
// Admin portal: leave / grievance / approval / document items waiting for HR or the Super Admin.
export const useAdminActionCounts = (enabled = true) => useCounts(["adminActionCounts"], "/action-counts/admin", enabled);
